import React from 'react'
import { List, WhiteSpace } from 'antd-mobile'
import styles from './style.module.scss'

interface ListItemProps {
  title: string
  subTitle: string
  count: string
  status: '1' | '2'
}

const statusText = {
  0: '未支付',
  1: '待完成',
  2: '已完成',
}

const ListItem: React.FC<ListItemProps> = (props) => {
  const { title, subTitle, count, status } = props
  return (
    <List.Item
      className={styles.item}
      extra={
        <div>
          <b className="color-orange text-lg">{count}</b>
          <WhiteSpace size="sm" />
          <div className="text-sm">{statusText[status]}</div>
        </div>
      }
    >
      {title}
      <List.Item.Brief>
        <div className="text-sm">{subTitle}</div>
      </List.Item.Brief>
    </List.Item>
  )
}

export default ListItem
